import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {
  FaqBuilder,
  InfoDropdown,
  InfoDropdownContent,
} from 'src/app/components/faq/faq.component';
import GlobalFaqs from "../../global-faqs";

@Component({
  selector: 'pla-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.css'],
})
export class InfoComponent implements OnInit {
  public glossaryUrl: string = '';
  public faq: InfoDropdown[] = GlobalFaqs.GetFaqsByKey('Info');

  constructor(private activatedRoute: ActivatedRoute) {
    this.glossaryUrl = this.activatedRoute.snapshot.paramMap.get('term') || '';
  }

  ngOnInit(): void {
  }
}
